import React, { useState, useEffect } from 'react';
import Panel from '../../controls/Panel';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '../../controls/Button';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { apiGet } from '../../api';
import { useAccessTokens } from '../../Authenticate';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingbottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    contentSpacer: {
        marginTop: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(10),
        },
    },
    button: {
        paddingbottom: theme.spacing(2),
        paddingTop: theme.spacing(4),
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

export default function FindLicensee() {
    const classes = useStyles();
    const [personId, setPersonId] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [fullName, setFullName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { getAccessToken, authorizationScopes } = useAccessTokens();
    const [person, setPerson] = useState();
    const [resultList, setResultList] = useState();
    const history = useHistory();

    useEffect(() => {
        if (person) {
            history.push(`/licensees/${personId}`, { person });
        } else if (resultList) {
            history.push('/licenseeResults', { resultList });
        }
    }, [person, history, personId, resultList]);

    const findLicensee = async () => {
        try {
            const token = await getAccessToken(authorizationScopes.persons)
            let licensee;

            if (personId && !firstName && !lastName & !fullName) {
                licensee = (await apiGet(`persons/${personId}`, token)).data;
            } else if (fullName && !firstName && !lastName) {
                licensee = (await apiGet(`persons?filter[where][name]=${fullName}`, token)).data;
            } else if (!fullName && firstName && lastName) {
                licensee = (await apiGet(`persons?filter[where][name.firstName]=${firstName}&filter[where][name.lastName]=${lastName}`, token)).data;
            } else if ((fullName && firstName) || (fullName && lastName)) {
                setErrorMessage('Do not use First Name or Last Name with Facility Name.');
            } else if ((firstName && !lastName) || (!firstName && lastName)) {
                setErrorMessage('Use both First Name and Last Name to search for a person by name.');
            }

            if (licensee && licensee.length) {
                setResultList(licensee);
            } else if (licensee) {
                setPerson(licensee);
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setErrorMessage('No matching record found. Please try again.');
            } else {
                setErrorMessage('We are unable to find the requested licensee. Please contact IT support.');
            }
        }
    };

    const handlePersonIdChange = (e) => {
        setPersonId(e.target.value);
        setFirstName('');
        setLastName('');
        setFullName('');
        setErrorMessage('');
    };

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
        setPersonId('');
        setFullName('');
        setErrorMessage('');
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
        setPersonId('');
        setFullName('');
        setErrorMessage('');
    };

    const handleFullNameChange = (e) => {
        setFullName(e.target.value);
        setPersonId('');
        setFirstName('');
        setLastName('');
        setErrorMessage('');
    };

    return (
        <>
            <Grid container item xs={12} spacing={4} justifyContent="center" alignItems="center" direction="column">
                <div className={classes.contentSpacer} />
                <Grid item xs={12} sm={8} container spacing={4} direction="column">
                    <Grid item>
                        <Panel>
                            <form>
                                <div className={classes.container}>
                                    <Typography variant="h6">Find Licensee</Typography>
                                </div>
                                <div className={classes.container}>
                                    <Typography variant="body1">
                                        Search for a licensee below to view associated profiles:
                                    </Typography>
                                </div>
                                <Grid container className={classes.container}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="personId"
                                            variant="outlined"
                                            onChange={handlePersonIdChange}
                                            value={personId}
                                            label="Person ID"
                                            name="personId"
                                            fullWidth
                                            onKeyDown={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    ev.preventDefault();
                                                    findLicensee();
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.container}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="firstName"
                                            variant="outlined"
                                            onChange={handleFirstNameChange}
                                            value={firstName}
                                            label="First Name"
                                            name="firstName"
                                            fullWidth
                                            onKeyDown={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    ev.preventDefault();
                                                    findLicensee();
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.container}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="lastName"
                                            variant="outlined"
                                            onChange={handleLastNameChange}
                                            value={lastName}
                                            label="Last Name"
                                            name="lastName"
                                            fullWidth
                                            onKeyDown={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    ev.preventDefault();
                                                    findLicensee();
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.container}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="fullName"
                                            variant="outlined"
                                            onChange={handleFullNameChange}
                                            value={fullName}
                                            label="Facility Name"
                                            name="fullName"
                                            fullWidth
                                            onKeyDown={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    ev.preventDefault();
                                                    findLicensee();
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                {errorMessage && <DialogContentText color="error">{errorMessage}</DialogContentText>}
                                <div className={classes.button}>
                                    <Button onClick={findLicensee} variant="contained" color="primary">
                                        Find Licensee
                                    </Button>
                                </div>
                            </form>
                        </Panel>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
